import { render } from "./balance.vue?vue&type=template&id=79b83e80"
import script from "./balance.js?vue&type=script&lang=js&external"
export * from "./balance.js?vue&type=script&lang=js&external"

import "./balance.vue?vue&type=style&index=0&id=79b83e80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__